import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Newspaper } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ArticlesPreview() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    axios.get(`${API}/articles`).then((r) => setArticles(r.data.slice(0, 3))).catch(() => {});
  }, []);

  return (
    <section id="articles" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 border-t border-[#0D1117]/10" data-testid="articles-preview-section">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-12">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4E00] mb-5 flex items-center gap-3">
            <Newspaper className="w-4 h-4" /> Articles
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-[#0D1117] tracking-tight">
            Field notes for better <span className="italic text-[#FF4E00]">miles.</span>
          </h2>
        </div>
        <Link to="/articles" data-testid="articles-preview-link" className="group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF4E00] hover:text-[#E04000] transition-colors">
          Browse all articles <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:rotate-45" />
        </Link>
      </div>
      {articles.length === 0 ? (
        <div className="rounded-3xl border border-dashed border-[#0D1117]/15 bg-[#FFFFFF] p-10 text-center">
          <p className="font-serif text-2xl text-[#0D1117]">Fresh stories are on the way.</p>
          <p className="text-sm text-[#6B7280] mt-2">Race reports, training guides and travel notes will appear here once published.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link key={article.id} to={`/articles/${article.slug}`} data-testid="article-preview-card" className="group rounded-3xl border border-[#0D1117]/10 bg-[#FFFFFF] overflow-hidden hover:border-[#FF4E00]/40 transition-colors">
              <div className="aspect-[16/9] bg-[#F4F2EC] overflow-hidden">
                {article.cover_url && <img src={`${process.env.REACT_APP_BACKEND_URL}${article.cover_url}`} alt={article.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />}
              </div>
              <div className="p-6">
                <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-[#FF4E00] mb-3">{article.category}</p>
                <h3 className="font-serif text-xl text-[#0D1117] group-hover:text-[#FF4E00] transition-colors">{article.title}</h3>
                <p className="text-sm text-[#6B7280] mt-3 line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
